import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nv9xwbyzy: FaireProductEntity = {
  token: "p_5nv9xwbyzy",
  type: "product",
  name: "Butter Pecan Fudge with Home-Roasted Pecans",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/41553dc7d56c9b9d9944fde6e92727e27c55dd392417e8d9d6193d3ad05a29ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53894af80cff3fe6be202df9fdcf3448097f28e0f3e48e1bf040781387e7fab7.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "We jazzed up the plain vanilla fudge by adding butter pecan flavoring and meaty home-roasted pecan halves. The taste is very similar to the ice cream by the same name. So if you like butter pecan ice cream, and we use a lot of pecans, you should also love ours. The advantage to ours is you don’t need a cone or a freezer although fudge tastes great cold too! FREE SHIPPING on all orders over $55. \n\nButter pecan flavor with pecan halves in a 1/2 lb resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:10.302Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
